import styled from 'styled-components'

import { Color } from 'root-constants'

type TStyledModalProps = {
  isShown: boolean
}

export const StyledModal = {
  Wrapper: styled.div<TStyledModalProps>`
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${({ isShown }) => (isShown ? 10 : -1)};
    width: max(100%, var(--min-screen-width));
    height: calc(var(--full-height) - calc(var(--full-height) - 100%));
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.25);
    opacity: ${({ isShown }) => (isShown ? 1 : 0)};
    transition-duration: 100ms;
    transition-property: opacity;
    transition-timing-function: ease-out;
  `,
  Content: styled.div`
    width: 310px;
    margin: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    border-radius: 10px;
    background-color: ${Color.WHITE};
  `,
  Title: styled.h2`
    padding-bottom: 10px;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
  `,
  Text: styled.p`
    font-size: 16px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 310px;
    padding: 0 24px 16px 24px;
  `,
  Email: styled.span`
    font-weight: 600;
  `,
  ContactSupport: styled.div`
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #15192080;
    padding-bottom: 24px;
    text-align: center;
  `,
  HelpCenterLink: styled.a`
    text-decoration-line: underline;
    text-transform: capitalize;
    color: ${Color.LINK_COLOR};
  `,
}
